var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47656 8V24C5.47656 24.5304 5.68728 25.0391 6.06235 25.4142C6.43742 25.7893 6.94613 26 7.47656 26H27.4766C27.7418 26 27.9961 25.8946 28.1837 25.7071C28.3712 25.5196 28.4766 25.2652 28.4766 25V11C28.4766 10.7348 28.3712 10.4804 28.1837 10.2929C27.9961 10.1054 27.7418 10 27.4766 10H7.47656C6.94613 10 6.43742 9.78929 6.06235 9.41421C5.68728 9.03914 5.47656 8.53043 5.47656 8ZM5.47656 8C5.47656 7.46957 5.68728 6.96086 6.06235 6.58579C6.43742 6.21071 6.94613 6 7.47656 6H24.4766",
    stroke: "#00AEC0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4766 18C23.4766 18.2761 23.2527 18.5 22.9766 18.5C22.7004 18.5 22.4766 18.2761 22.4766 18C22.4766 17.7239 22.7004 17.5 22.9766 17.5C23.2527 17.5 23.4766 17.7239 23.4766 18Z",
    fill: "#18191C",
    stroke: "#00AEC0",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExp);
export default __webpack_public_path__ + "static/media/exp.ecbf5699085b275a0ea1dd9dca92e61c.svg";
export { ForwardRef as ReactComponent };